module.exports = __webpack_public_path__ + "static/media/account_icon_level3.3422ea72.svg";